import { render, staticRenderFns } from "./PacedFulfillmentUnits.vue?vue&type=template&id=36094384"
import script from "./PacedFulfillmentUnits.vue?vue&type=script&lang=js"
export * from "./PacedFulfillmentUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports